<template>
    <div>
        <el-empty description="" v-show="!isChartShow"></el-empty>
        <div v-if="chartData!=undefined" :id="chartData.chartid"></div>
    </div>
</template>

<script>
    import Plotly from 'plotly.js-dist'
    import * as d3 from 'd3'

    export default {
        name: 'Plotchart',
        props: {
            chartData: {
                type: Object
            },
            chartType: {
                type: Number
            }
        },
        data() {
            return {
                isChartShow: false
            }
        },
        watch: {
            chartData: {//深度监听，可监听到对象、数组的变化
                handler(newVal) {
                    if (newVal) {
                        this.$nextTick(() => {
                            this.isChartShow = false;
                            switch (this.chartType) {
                                case 1://line
                                    this.plotline(newVal);
                                    break;
                                case 2://3d
                                    this.plot3d(newVal);
                                    break;
                                default:
                                    this.plot3d(newVal);
                            }

                            this.isChartShow = true;
                        });
                    }
                },
                deep: true //true 深度监听
            }
        },
        computed: {
        },
        created() {

        },
        methods: {
            plotline(line_data) {
                var data = line_data.pdata;
                var dataxy = [];
                if (data.length > 1) {
                    for (var i = 0; i < data.length - 1; i++) {
                        var dataitem = {
                            x: data[0],
                            y: data[i + 1],
                            name: '峰值',
                            //type: 'lines+markers',
                            mode: 'lines+markers'
                        };
                        dataxy.push(dataitem);
                    }
                }
                let layout = {
                    title: '峰值变化图 ' + line_data.title,
                    titlefont: {
                        size: 20,
                        color: '#1F77B4'
                    },
                    plot_bgcolor: '#FAFAFA',
                    showlegend: false,
                    autosize: true,
                    //width: line_data.size.width,
                    //width:'100%',
                    height: line_data.size.height,
                    xaxis: {
                        //title: '时间',
                        showgrid: false,
                        //tickvals: data[0],
                        ticklabelposition: "outside",
                        //tickformat: '%m.%d %H:%M',
                        type:'category',
                        tickangle:30,
                        tickfont: {
                            size: 10,
                            color: '#a9a9a9'
                        },
                        titlefont: {
                            size: 16,
                            color:'#a9a9a9'
                        }
                    },
                    yaxis: {
                        title: '峰值',
                        nticks: 20,
                        tickfont: {
                            size: 11,
                            color: '#a9a9a9'
                        },
                        titlefont: {
                            size: 16,
                            color: '#a9a9a9'
                        }
                    },
                    margin: {
                        l: 50,
                        r: 0,
                        b: 45,
                        t: 50,
                    }
                };
                Plotly.newPlot(this.chartData.chartid, dataxy, layout, { displaylogo: false, displayModeBar: false, responsive: true});
            },
            plot3d(surface3d_data) {
                let z_data = this.parse_3ddata(surface3d_data.pdata)
                let x = d3.range(250, 651)
                let y = d3.range(220, 501, 5)
                let zmax = d3.max(z_data, function (d) {
                    return d3.max(d);
                });
                let data = [{
                    z: z_data,
                    x: x,
                    y: y,
                    type: 'surface',
                    contours: {
                        z: {
                            show: true,
                            usecolormap: true,
                            highlightcolor: "#42f462",
                            project: { z: true }
                        }
                    }
                }];
                let layout = {
                    title: '',
                    scene: {
                        displayModeBar: false,
                        camera: { eye: { x: 1.4, y: 1.4, z: 1.3 } },
                        xaxis: {
                            nticks: 9,
                            range: [250, 650],
                        },
                        yaxis: {
                            nticks: 7,
                            range: [220, 500],
                        },
                        zaxis: {
                            nticks: 10,
                            range: [0, zmax],
                        }
                    },
                    autosize: false,
                    width: surface3d_data.size.width,
                    height: surface3d_data.size.height,
                    margin: {
                        l: 30,
                        r: 0,
                        b: 0,
                        t: 0,
                    }
                };
                Plotly.newPlot(this.chartData.chartid, data, layout, {displaylogo: false, displayModeBar: false, modeBarButtonsToRemove: ['pan2d', 'lasso2d'] });
            },
            parse_3ddata(pdata) {
                let data = []
                pdata.forEach(line => {
                    let line_data = []
                    let items = line.split(',')
                    items.forEach(item => line_data.push(item * 1.))
                    data.push(line_data)
                })
                return data
            }
        }
    }
</script>

<style>

</style>